// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__lxNjB","form":"styles_form__xqz+N"};